// 公司管理列表筛选条件
export let companyTableFilter = [{
    label: '地区',
    type: 'select',
    clearable: true,
    filterable: true,
    value: 'role',
    options: [],
    props: {
      label: 'displayName',
      value: 'id'
    }
  }]
  // 分子公司列表表头
export let companyTableLabels = [{
      label: '公司名称',
      value: 'fullName'
    },
    {
      label: '简称',
      value: 'name'
    },
    {
      label: '公司性质',
      value: 'typeName'
    },
    {
      label: '业务类型',
      value: 'businessName'
    },
    {
      label: '地区',
      value: 'addresses'
    },
    {
      label: "收款方名称",
      value: "payeeName"
    },
    {
      label: "电话号码",
      value: "telephone"
    },
    {
      label: '条码号前缀',
      value: 'codePrefix'
    },
    {
      label: "CPS系统ID",
      value: "externalId"
    }
    // {
    //   label: '微信特约商户号',
    //   value: 'weChatMerchantCode'
    // },
    // {
    //   label: '支付宝授权应用APPID',
    //   value: 'alipayAuthAppId'
    // }
  ]
  // 分/子公司详情tabs
export let companyTabs = [{
    label: '分/子公司信息',
    value: 'company'
  },
  {
    label: '支付信息',
    value: 'payment'
  }
]